export default function Methodology({ settings = {} }) {
  const steps = [
    {
      num: '01',
      title: settings.methodology_step1_title || 'Diagnose',
      desc: settings.methodology_step1_desc || 'We audit your business model, target market, and tech stack to find the highest-impact opportunities for growth.',
      icon: (
        <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
        </svg>
      ),
    },
    {
      num: '02',
      title: settings.methodology_step2_title || 'Build',
      desc: settings.methodology_step2_desc || 'We design and develop your solution with conversion in mind — every feature ties back to a revenue metric.',
      icon: (
        <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4" />
        </svg>
      ),
    },
    {
      num: '03',
      title: settings.methodology_step3_title || 'Measure',
      desc: settings.methodology_step3_desc || "We track real business outcomes — revenue, conversion rates, user retention — and iterate based on data, not guesses.",
      icon: (
        <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
        </svg>
      ),
    },
  ];

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Our Process: <span className="text-blue-600">{settings.methodology_name || 'Revenue-Driven Development'}</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Every project follows our proven 3-step framework that ensures your investment delivers measurable business results.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {steps.map((step, i) => (
            <div key={i} className="relative">
              {i < steps.length - 1 && (
                <div className="hidden md:block absolute top-16 left-full w-full h-0.5 bg-gradient-to-r from-blue-300 to-transparent -translate-x-8 z-0" />
              )}
              <div className="bg-gradient-to-br from-blue-50 to-white p-8 rounded-xl border border-blue-100 relative z-10">
                <div className="flex items-center justify-between mb-6">
                  <div className="text-blue-600">{step.icon}</div>
                  <span className="text-5xl font-bold text-blue-100">{step.num}</span>
                </div>
                <h3 className="text-2xl font-bold mb-3">{step.title}</h3>
                <p className="text-gray-600">{step.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
